<template>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <span
            style="font-size: 14px"
            class="font-weight-bold black--text mb-0"
          >
            {{ '#' + tagName }}
          </span>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <span
            style="font-size: 13px"
            class="grey--text mr-2"
            >{{ tagCount + ' ' + $t('title.content') }}</span
          >
      </v-list-item-action>
    </v-list-item>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    tagName:String,
    tagCount: Number,
  },
  components: {
  },
  mounted() {},
  methods: {
  },
  computed: {},
};
</script>

<style>

</style>
